import { environment } from "src/environments/environment";

export const ApiUrlConstants = {
  login: `${environment.apiUrl}/api/Auth/Login`,
  getToken: `${environment.apiUrl}/api/Common/GetToken`,
  forgotPasswordSendCode: `${environment.apiUrl}/api/Auth/ForgotPasswordSendCode`,
  resetPasswordByCode: `${environment.apiUrl}/api/Auth/ResetPasswordByCode`,

  getAllRole: `${environment.apiUrl}/api/Role`,
  getAllDesignation: `${environment.apiUrl}/api/Designation/GetAll`,
  //Start - User Module
  userGetAllForList: `${environment.apiUrl}/api/User/GetAllForList`,
  userGetAllWithShortDetails: `${environment.apiUrl}/api/User/GetAllWithShortDetails`,
  addUsers: `${environment.apiUrl}/api/User/Add`,
  getUserById: `${environment.apiUrl}/api/User/GetById/`,
  updateUserById: `${environment.apiUrl}/api/User/update`,
  activeInactiveUser: `${environment.apiUrl}/api/User/ActiveInactiveUser`,
  deleteUser: `${environment.apiUrl}/api/User/Delete`,
  UserResetPassword: `${environment.apiUrl}/api/User/UserResetPassword`,
  ResetPassword: `${environment.apiUrl}/api/Common/ResetPassword`,
  GetLoggedInUserDetails: `${environment.apiUrl}/api/Common/GetLoggedInUserDetails`,
  ChangeProfilePic: `${environment.apiUrl}/api/Common/ChangeProfilePic`,
  switchRole: `${environment.apiUrl}/api/Common/SwitchRole/`,
  userGetAllCityManagersByCityId: `${environment.apiUrl}/api/User/GetAllCityManagersByCityId/`,
  userGetAllActiveAccountExMgrAndCoordinator: `${environment.apiUrl}/api/User/GetAllActiveAccountExMgrAndCoordinator`,
  userGetAllActiveAccountManagers: `${environment.apiUrl}/api/User/GetAllActiveAccountManager`,
  userGetAllActiveEstimators: `${environment.apiUrl}/api/User/GetAllActiveEstimator`,
  userGetAllActiveCityManagers: `${environment.apiUrl}/api/User/GetAllActiveCityManager`,

  //End - User Module

  //Start - Weekly Meeting Module
  GetAllDept: `${environment.apiUrl}/api/WeeklyMeetDoc/GetAllDept`,
  GetAllUploadList: `${environment.apiUrl}/api/WeeklyMeetDoc/GetAllUploadList`,
  uploadWeeklyMeetDoc: `${environment.apiUrl}/api/WeeklyMeetDoc/Upload`,
  weeklyDocumentActiveInactive: `${environment.apiUrl}/api/WeeklyMeetDoc/ActiveInactive`,
  weeklyMeetDocDownload: `${environment.apiUrl}/api/WeeklyMeetDoc/Download/`,
  //End - Weekly Meeting Module

  //Start - Country Management Module
  countryGetAll: `${environment.apiUrl}/api/Country`,
  //End - Country Management Module

  //Start - State Management Module
  stateGetAllByCountryId: `${environment.apiUrl}/api/State/GetAllByCountryId/`,
  stateGetAllWithShortDetails: `${environment.apiUrl}/api/State/GetAllWithShortDetails`,
  statesGetAllWithCountryRegions: `${environment.apiUrl}/api/State/GetAllStatesWithCountryRegions`,
  regionsGetAll: `${environment.apiUrl}/api/Region/GetAll`,
  stateCreate: `${environment.apiUrl}/api/State/Create`,
  stateGetById: `${environment.apiUrl}/api/State/GetState/`,
  stateUpdate: `${environment.apiUrl}/api/State/Update`,

  //End - State Management Module

  //Start - City Management Module
  cityGetAllWithShortDetails: `${environment.apiUrl}/api/City/GetAllWithShortDetails`,
  cityGetByStateId: `${environment.apiUrl}/api/City/GetAllByStateId/`,
  cityGetAllWithDetails: `${environment.apiUrl}/api/City/GetAllWithDetails`,
  cityGetAllBaseCitiesByStateId: `${environment.apiUrl}/api/City/GetAllBaseCitiesByStateId/`,
  cityCreate: `${environment.apiUrl}/api/City/Create`,
  cityGetById: `${environment.apiUrl}/api/City/GetCityById/`,
  citUpdate: `${environment.apiUrl}/api/City/Update`,
  cityHolidayUpdate: `${environment.apiUrl}/api/City/UpdateCityHoliday`,
  cityGetAllByBaseCityId: `${environment.apiUrl}/api/City/GetAllByBaseCityId/`,
  cityGetAllBaseCities: `${environment.apiUrl}/api/City/GetAllBaseCities`,
  cityGetAllBaseCitiesByStateIds: `${environment.apiUrl}/api/City/GetAllBaseCitiesByStateIds`,
  cityGetAllSOByCityId: `${environment.apiUrl}/api/City/GetAllSOByCityId/`,
  //End - City Management Module

  //Start - Material Management Module
  materialGetAllWithDetails: `${environment.apiUrl}/api/Material/GetAllWithAllDetails`,
  materialGetById: `${environment.apiUrl}/api/Material/GetDetailsById/`,
  materialGetAllWithShortDetails: `${environment.apiUrl}/api/Material/GetAllWithShortDetails`,
  materialUnitGetAll: `${environment.apiUrl}/api/Material/GetAllMaterialUnitList`,
  materialGroupGetAll: `${environment.apiUrl}/api/Material/GetAllMaterialGroupList`,
  materialAdd: `${environment.apiUrl}/api/Material/Add`,
  materialUpdate: `${environment.apiUrl}/api/Material/Update`,
  materialUnitAdd: `${environment.apiUrl}/api/Material/UnitAdd`,
  materialUnitUpdate: `${environment.apiUrl}/api/Material/UnitUpdate`,
  materialGetAllWithCustom: `${environment.apiUrl}/api/Material/GetAllMaterialsWithCustom`,
  materialByIdGetAllSO: `${environment.apiUrl}/api/Material/GetAllSOByMaterialId/`,
  materialUpdateWithSO: `${environment.apiUrl}/api/Material/UpdateWithSO`,
  //End - Material Management Module

  //Start - General City Management Module
  generalCityGetAllForList: `${environment.apiUrl}/api/GeneralCity/GetAllForList`,
  generalCityGetAllWithShortDetails: `${environment.apiUrl}/api/GeneralCity/GetAllWithShortDetails`,
  generalCityGetById: `${environment.apiUrl}/api/GeneralCity/GetById/`,
  generalCityAdd: `${environment.apiUrl}/api/GeneralCity/Add`,
  generalCityUpdate: `${environment.apiUrl}/api/GeneralCity/Update`,
  generalCityGetAllByStateId: `${environment.apiUrl}/api/GeneralCity/GetAllWithShortDetailsByStateId/`,
  //End - General City Management Module

  //Start - Venue Management Module
  venueGetAllForList: `${environment.apiUrl}/api/Venue/GetAllForList`,
  venueGetAllWithShortDetails: `${environment.apiUrl}/api/Venue/GetAllWithShortDetails`,
  venueGetAllCategory: `${environment.apiUrl}/api/Venue/GetAllCategory`,
  venueGetById: `${environment.apiUrl}/api/Venue/GetById/`,
  venueAdd: `${environment.apiUrl}/api/Venue/Add`,
  venueUpdate: `${environment.apiUrl}/api/Venue/Update`,
  venueDeleteById: `${environment.apiUrl}/api/Venue/Delete/`,
  //End - Venue Management Module

  //Start - Manage City Manager
  CityManageGetAllCityWithAllocations: `${environment.apiUrl}/api/CityManagerAllocation/GetAllCityWithAllocations`,
  cityManagGetAllCityManagerWithAllocation: `${environment.apiUrl}/api/CityManagerAllocation/GetAllCityManagerWithAllocation`,
  cityManageAddUpdate: `${environment.apiUrl}/api/CityManagerAllocation/AddUpdate`,
  cityManageAllBaseCitiesByBaseCityId: `${environment.apiUrl}/api/CityManagerAllocation/GetAllCitiesByBaseCityId/`,
  cityManagerAllocationDelete: `${environment.apiUrl}/api/CityManagerAllocation/Delete/`,
  cityManagerRemoveAllocationByBaseCityId: `${environment.apiUrl}/api/CityManagerAllocation/RemoveAllocationByBaseCityId`,
  cityManagGetAllCitiesByCityManagerId: `${environment.apiUrl}/api/CityManagerAllocation/GetAllCitiesByCityManagerId/`,
  //End Manage City Manager

  //Start - System Role
  systemRoleGetAllRolesWithAssignedModules: `${environment.apiUrl}/api/RoleModuleFeature/GetAllRolesWithAssignedModules`,
  systemRoleGetAllAssignedModulesByRoleId: `${environment.apiUrl}/api/RoleModuleFeature/GetAllAssignedModulesByRoleId/`,
  systemRoleGetAllModules: `${environment.apiUrl}/api/RoleModuleFeature/GetAllModules`,
  systemRoleAssignedModuleToRole: `${environment.apiUrl}/api/RoleModuleFeature/AssignedModuleToRole`,
  //End System Role
  //Start - Show Management
  getShowCategoryAll: `${environment.apiUrl}/api/Show/GetShowCategoryAll`,
  getShowTypeAll: `${environment.apiUrl}/api/Show/GetShowTypeAll`,
  getShowYearAll: `${environment.apiUrl}/api/Show/GetShowYearAll`,
  getShowVenueAll: `${environment.apiUrl}/api/Show/GetShowVenueAll`,
  getShowDateRangeAll: `${environment.apiUrl}/api/Show/GetShowDateRangeAll`,
  getShowListAll: `${environment.apiUrl}/api/Show/GetAllForList`,
  getFutureShowListAll: `${environment.apiUrl}/api/Show/GetAllFutureForList`,
  getAllShowForDropdownList: `${environment.apiUrl}/api/Show/GetAllShowForDropdownList`,
  getShowIndustryAll: `${environment.apiUrl}/api/Show/GetShowIndustryAll`,
  getShowFileCategoryAll: `${environment.apiUrl}/api/Show/GetShowFileCategoryAll`,
  addShow: `${environment.apiUrl}/api/Show/Add/`,
  updateShow: `${environment.apiUrl}/api/Show/Update/`,
  cloneShow: `${environment.apiUrl}/api/Show/Clone/`,
  showFileDownload: `${environment.apiUrl}/api/Show/ShowFileDownload/`,
  showFileDelete: `${environment.apiUrl}/api/Show/ShowFileDelete/`,
  //GetShowGeneralContractorList
  getShowGeneralContractorList: `${environment.apiUrl}/api/Show/GetShowGeneralContractorList`,
  getShowById: `${environment.apiUrl}/api/Show/GetById/`,
  getSamplePdf: `${environment.apiUrl}/api/Show/GetPDF/`,
  showByIdSoListForEACFee: `${environment.apiUrl}/api/Show/GetAllSOByShowIdForEACFee/`,
  showByIdSoListForMoveDateChange: `${environment.apiUrl}/api/Show/GetAllSOByShowIdForMoveDateChanges/`,
  showUpdateMoveDates: `${environment.apiUrl}/api/Show/ShowMoveDateUpdates`,
  //End - Show Management

  //Start - Client Contact Role
  clientContactRoleGetAllList: `${environment.apiUrl}/api/ClientContactRole/GetAllForList`,
  clientContactRoleGetById: `${environment.apiUrl}/api/ClientContactRole/GetById/`,
  clientContactRoleAdd: `${environment.apiUrl}/api/ClientContactRole/Add`,
  clientContactRoleUpdate: `${environment.apiUrl}/api/ClientContactRole/Update`,
  clientContactRoleDelete: `${environment.apiUrl}/api/ClientContactRole/Delete/`,
  clientContactGetAllActive: `${environment.apiUrl}/api/ClientContactRole/GetAllActive`,

  //End - Client Contact Role

  //Start Client Management
  clientGetAll: `${environment.apiUrl}/api/Client/GetAll`,
  clientGetAllForDropdown: `${environment.apiUrl}/api/Client/GetAllForDropdown`,
  clientGetAllExhibitorForDropdown: `${environment.apiUrl}/api/Client/GetAllExhibitorForDropdown`,
  clientGetById: `${environment.apiUrl}/api/Client/GetById/`,
  clientAdd: `${environment.apiUrl}/api/Client/Add`,
  clientUpdate: `${environment.apiUrl}/api/Client/Update`,
  clientGetTeamByClientShowId: `${environment.apiUrl}/api/Client/GetClientTeamByClientShowId`,
  clientGetAllByClientTypeForSO: `${environment.apiUrl}/api/Client/GetAllForSOByClientType/`,
  clientGetDetailsForSOByClientShowId: `${environment.apiUrl}/api/Client/GetClientDetailsForSOByClientShowId`,
  clientSoListForTeamAllocation: `${environment.apiUrl}/api/Client/GetAllSOByClientIdForTeamChange/`,
  clientAddressesGetById: `${environment.apiUrl}/api/Client/GetClientAddressesByClientId/`,
  clientGetAllByAccountType: `${environment.apiUrl}/api/Client/GetAllClientByAccountType/`,

  //End Client Management

  //Start Rate Card
  rateCardGetAllActive: `${environment.apiUrl}/api/RateCard/GetAllActive`,
  rateCardGetAll: `${environment.apiUrl}/api/RateCard/GetAll`,
  rateCardDownloadTemplateByBaseCityId: `${environment.apiUrl}/api/RateCard/DownloadRateCardTemplateByBaseCityId/`,
  rateCardImport: `${environment.apiUrl}/api/RateCard/ImportRateCard`,
  rateCardAdd: `${environment.apiUrl}/api/RateCard/Add`,
  rateCardUpdate: `${environment.apiUrl}/api/RateCard/Update`,
  rateCardGetById: `${environment.apiUrl}/api/RateCard/GetById/`,
  rateCardGetAllByCityIdForSOEstimation: `${environment.apiUrl}/api/RateCard/GetAllByCityIdForSOEstimation/`,
  rateCardByIdSOList: `${environment.apiUrl}/api/RateCard/GetAllSOByRateCardId/`,
  rateCardUpdateWithSO: `${environment.apiUrl}/api/RateCard/UpdateWithSO`,
  //End Rate Card

  //Start Labor
  laborGetAll: `${environment.apiUrl}/api/Labor/GetAllLabors`,
  laborGetById: `${environment.apiUrl}/api/Labor/GetById/`,
  laborAdd: `${environment.apiUrl}/api/Labor/Add`,
  laborUpdate: `${environment.apiUrl}/api/Labor/Update`,
  laborUpdatePin: `${environment.apiUrl}/api/Labor/UpdatePin`,
  laborGetAllByCityId: `${environment.apiUrl}/api/Labor/GetAllLaborsByCityId/`,
  laborGetAllWithAllocatedBaseCity: `${environment.apiUrl}/api/Labor/GetAllLaborsWithAllocatedBaseCity`,
  laborGetAllWithAllocatedBaseCityForLbrList: `${environment.apiUrl}/api/Labor/GetAllLaborsWithAllocatedBaseCityForLbrList`,
  laborGetAllLeadman: `${environment.apiUrl}/api/Labor/GetAllLeadmans`,
  //End Labor

  //Start Labor Tax Rule Wages
  laborTaxRuleWagesGetById: `${environment.apiUrl}/api/LaborTaxRule/GetById/`,
  laborTaxRuleWagesAdd: `${environment.apiUrl}/api/LaborTaxRule/Add`,
  laborTaxRuleWagesUpdate: `${environment.apiUrl}/api/LaborTaxRule/Update`,
  laborTaxRuleWagesUpdateWithSO: `${environment.apiUrl}/api/LaborTaxRule/UpdateWithSO`,
  laborTaxRuleSOListGetById: `${environment.apiUrl}/api/LaborTaxRule/GetAllSOByLaborTaxRuleId/`,

  //End Labor Tax Rule Wages

  //Start Landing Page
  landingPageAdd: `${environment.apiUrl}/api/LandingPage/Add`,
  landingPageUpdate: `${environment.apiUrl}/api/LandingPage/Update`,
  landingPageGet: `${environment.apiUrl}/api/LandingPage/Get`,
  //End Landing Page

  //Start Holiday Management
  holidayAdd: `${environment.apiUrl}/api/Holiday/Add`,
  holidayUpdate: `${environment.apiUrl}/api/Holiday/Update`,
  holidayGetById: `${environment.apiUrl}/api/Holiday/GetById/`,
  holidayGetAll: `${environment.apiUrl}/api/Holiday/GetAll`,
  holidayGetAllByStateId: `${environment.apiUrl}/api/Holiday/GetAllByStateId/`,
  //End Holiday Management

  //Start - Service Order Module
  soGetAll: `${environment.apiUrl}/api/SO/GetAll`,
  soGetAllNew: `${environment.apiUrl}/api/SO/GetAllNew`,
  soGetAllSOFullNumber: `${environment.apiUrl}/api/SO/GetAllSOFullNumber`,

  soGetById: `${environment.apiUrl}/api/SO/GetSOById/`,
  soISDGetById: `${environment.apiUrl}/api/SO/GetSOISDById/`,
  soGetAllListByShowId: `${environment.apiUrl}/api/SO/GetAllListByShowId/`,
  soAdd: `${environment.apiUrl}/api/SO/Add`,
  soGenInfoUpdate: `${environment.apiUrl}/api/SO/UpdateGenInfo`,
  soGenInfoUpdateBoothPO: `${environment.apiUrl}/api/SO/UpdateGenInfoBoothPO`,
  soRequestStatusUpdate: `${environment.apiUrl}/api/SO/SoRequestStatusUpdate`,
  soRequestStatusUnwin: `${environment.apiUrl}/api/SO/SoRequestStatusUnwin`,
  soClientProvideLaborInfoAdd: `${environment.apiUrl}/api/SO/AddClientProvideLaborInfo`,
  soGetInitiateExhDetails: `${environment.apiUrl}/api/SO/GetInitiateExhDetails`,
  soUpdateInitiateExhibitExhibitor: `${environment.apiUrl}/api/SO/UpdateInitiateExh`,
  soUpdateScopeSupervisionEAC: `${environment.apiUrl}/api/SO/UpdateScopeSupervisionEAC`,
  soGetAllScopeMaterials: `${environment.apiUrl}/api/SO/GetAllSoScopeMaterials/`,
  soUpdateScopeMaterials: `${environment.apiUrl}/api/SO/UpdateScopeMaterials`,
  soGetAllScopeEquipments: `${environment.apiUrl}/api/SO/GetAllSoScopeEquipments/`,
  soUpdateScopeEquipments: `${environment.apiUrl}/api/SO/SOUpdateScopeEquipments`,
  soUpdateScopeInstDism: `${environment.apiUrl}/api/SO/SoScopeInstDismAddUpdate`,
  soGetPrepareInboudFreight: `${environment.apiUrl}/api/SO/GetSoPrepareInboundFreight/`,
  soUpdatePrepareInboudFreight: `${environment.apiUrl}/api/SO/SOUpdatePrepareInboundFreight`,
  soPrepareInboundBillFileDownload: `${environment.apiUrl}/api/SO/SOPrepareInboundBillDownload/`,
  soGetPrepareOutboundFreight: `${environment.apiUrl}/api/SO/GetSoPrepareOutboundFreight/`,
  soUpdatePrepareOutboundFreight: `${environment.apiUrl}/api/SO/SOUpdatePrepareOutboundFreight`,
  soPrepareOutboundBillFileDownload: `${environment.apiUrl}/api/SO/SOPrepareOutboundBillDownload/`,
  soPrepareOutboundShipmenetDelete: `${environment.apiUrl}/api/SO/SOPrepareOutboundShipmentDelete/`,
  soPrepareSpInstructionGetAll: `${environment.apiUrl}/api/SO/GetAllSoPrepareSpInstructions/`,
  soPrepareSpInstructionAddUpdate: `${environment.apiUrl}/api/SO/SOPrepareSpecialInstructionAddUpdate`,
  soPrepareClientManageSpInstructionGetList: `${environment.apiUrl}/api/SO/SOPrepareClientManageInstructionsGetAll`,
  soPrepareSpInstructionDelete: `${environment.apiUrl}/api/SO/SOPrepareSpecialInstructionDelete/`,
  soViewUpdateSpecialInstNote: `${environment.apiUrl}/api/SO/SOViewUpdateSpecialInstNote`,
  soViewUpdateSpecialInstCatDisplay: `${environment.apiUrl}/api/SO/SOViewUpdateSpecialInstCategoryDisplay`,

  soScopeGetAllBoothFieldElement: `${environment.apiUrl}/api/SO/GetAllSoScopeBoothFieldElement/`,
  soScopeGetAllBoothFieldFiles: `${environment.apiUrl}/api/SO/GetAllSoScopeBoothFieldFile/`,
  soGetAllFieldFiles: `${environment.apiUrl}/api/SO/GetAllSoFieldFiles/`,
  soScopeBoothFieldAddUpdateDetails: `${environment.apiUrl}/api/SO/SOScopeBoothFieldAddUpdate`,
  soScopeBoothFieldElementAddUpdateDetails: `${environment.apiUrl}/api/SO/SOScopeBoothFieldElementAddUpdate`,
  soScopeBoothFieldFileUpload: `${environment.apiUrl}/api/SO/SOScopeBoothFieldFileUpload`,
  soScopeBoothFieldFileDownload: `${environment.apiUrl}/api/SO/SOScopeBoothFieldFileDownload/`,
  soScopeBoothFieldFileDelete: `${environment.apiUrl}/api/SO/SoScopeBoothFieldFileDelete/`,
  soScopeBoothFieldElementDelete: `${environment.apiUrl}/api/SO/SoScopeBoothFieldElementDelete/`,
  soScopeBoothFieldFileDownloadZip: `${environment.apiUrl}/api/SO/SOScopeBoothFieldFileDownloadZip`,
  soFieldFileDownloadZip: `${environment.apiUrl}/api/SO/SOFieldFileDownloadZip`,
  soGetAllRedFlagByServiceOrderId: `${environment.apiUrl}/api/SO/GetRedFlagList/`,
  soScopeBoothFieldPrint: `${environment.apiUrl}/api/SO/SOScopeBoothFieldFilePrint`,
  soFieldFilesPrint: `${environment.apiUrl}/api/SO/SOFieldFilePrint`,
  soPrintDocumentForShow: `${environment.apiUrl}/api/SO/SOPrintDocumentForShow`,

  soEACFormFileUpload: `${environment.apiUrl}/api/SO/SOEACFormFileUpload`,
  soEACFormFileDownload: `${environment.apiUrl}/api/SO/SOEACFormFileDownload/`,
  soEACFormdFileDelete: `${environment.apiUrl}/api/SO/SOEACFormFileDelete/`,

  soRedFlagCustomAddUpdate: `${environment.apiUrl}/api/SO/RedFlagCustomAddUpdate`,
  soRedFlagDetailsUpdateByUser: `${environment.apiUrl}/api/SO/RedFlagDetailsUpdateByUser`,
  soRedFlagCustomDelete: `${environment.apiUrl}/api/SO/RedFlagCustomDelete`,
  soScopeEstimationAddUpdate: `${environment.apiUrl}/api/SO/EstimationAddUpdate`,
  soScopeEstimationGet: `${environment.apiUrl}/api/SO/EstimationGetBySOId/`,
  soEstimationTravelFileDownload: `${environment.apiUrl}/api/SO/SoEstimationTravelFileDownload/`,
  soScopeEstimationForMigration: `${environment.apiUrl}/api/SO/EstimationUpdateForMigration`,
  soScopeEstimationForMigrationRateCard: `${environment.apiUrl}/api/SO/SoScopeEstimationUpdateForMigrationUpdateRateCard`,

  soGeneralFileUpload: `${environment.apiUrl}/api/SO/SOGeneralFileUpload`,
  soGeneralFileDownload: `${environment.apiUrl}/api/SO/SOGeneralFileDownload/`,
  soGeneralFileDelete: `${environment.apiUrl}/api/SO/SOGeneralFileDelete/`,
  soGetAllGeneralFilesByServiceOrderId: `${environment.apiUrl}/api/SO/SoGetAllGeneralFilesByServiceOrder/`,
  soCreateNewVersion: `${environment.apiUrl}/api/SO/SoCreateNewVersion/`,
  soSetActivate: `${environment.apiUrl}/api/SO/SetActivate/`,
  soGetAllVersionBySONumber: `${environment.apiUrl}/api/SO/GetAllVersionBySONumber/`,
  soPullOldData: `${environment.apiUrl}/api/SO/SOPullOldData`,
  soGetAllShortList: `${environment.apiUrl}/api/SO/GetAllSOShortList`,
  soGetClientFeedbackListBySoId: `${environment.apiUrl}/api/SO/GetSOClientFeedbackBySoId/`,
  soSentToClient: `${environment.apiUrl}/api/SO/SOSentToClient`,
  soViewSentToClient: `${environment.apiUrl}/api/SO/SOViewSentToClient`,
  soViewToClientHistoryListBySOId: `${environment.apiUrl}/api/SO/GetSoViewToClientHistoryListBySoId/`,
  soGetClientContacts: `${environment.apiUrl}/api/SO/GetSOClientContacts/`,
  soClientSendFeedbackToTeam: `${environment.apiUrl}/api/ClientFeedback/SOClientSendFeedbackToTeam`,
  soGetClientFeedbackForClient: `${environment.apiUrl}/api/ClientFeedback/SOGetClientFeedback/`,
  soGetActionPermission: `${environment.apiUrl}/api/SO/GetSOActionPermission/`,
  soAddExhibitHouseIfExhibitor: `${environment.apiUrl}/api/SO/SOAddExhibitHouseIfExhibitor`,
  soGetView: `${environment.apiUrl}/api/SO/GetSOView/`,
  soGetViewPdf: `${environment.apiUrl}/api/So/GetSOViewPDF`,//This is called from ServiceOrderViewComponent
  soDownloadViewPdf: `${environment.apiUrl}/api/SoView/DSoViewPdf/`,
  soGetShortDetails: `${environment.apiUrl}/api/SO/GetSOShortDetails/`,
  sendJobToCityManager: `${environment.apiUrl}/api/SO/SendJobToCityManager/`,
  sendJobToCityManagerAgain: `${environment.apiUrl}/api/SO/SendJobToCityManagerAgain/`,
  soGrabByEstimator: `${environment.apiUrl}/api/SO/EstimatorGrabSO/`,
  soCompleteByEstimator: `${environment.apiUrl}/api/SO/EstimatorMarkAsCompleteSO`,
  soGetAccountCoordinatorDashboardDetails: `${environment.apiUrl}/api/SO/GetAccountCoordinatorDashboard`,
  soSentReminderToClient: `${environment.apiUrl}/api/SO/SentReminderToClient/`,
  soRecReminderConfirmation: `${environment.apiUrl}/api/SO/RecReminderConfirmation/`,
  soUpdateCMLayout: `${environment.apiUrl}/api/SO/SOUpdateCMLayout/`,
  soRemoveCMLayoutForCanceled: `${environment.apiUrl}/api/SO/SORemoveCMLayoutForCanceled/`,
  soSendAgainToEstimator: `${environment.apiUrl}/api/SO/SOSendAgainToEstimator/`,
  soGetMoveDateChangesDetails: `${environment.apiUrl}/api/SO/GetMoveDateChangesForSO`,
  soMoveDateChanges: `${environment.apiUrl}/api/SO/SOMoveDateChanges`,
  soGetClientFacingTimesheetBySoId: `${environment.apiUrl}/api/SO/GetClientFacingTimesheetBySOId/`,
  soReadyToSentToClientClear: `${environment.apiUrl}/api/SO/ReadyToSentToClientClear/`,
  soMarkSOReadyForEstimator: `${environment.apiUrl}/api/SO/MarkSOReadyForEstimator/`,
  SoHoldStatusUpdate: `${environment.apiUrl}/api/SO/SOHoldStatusUpdate`,
  //End - Service Order Module

  //Start Equipment
  equipmentAdd: `${environment.apiUrl}/api/Equipment/Add`,
  equipmentDelete: `${environment.apiUrl}/api/Equipment/Delete/`,
  equipmentGetAllWithShortDetails: `${environment.apiUrl}/api/Equipment/GetAllWithShortDetails`,

  //End Equipment

  //Start Messaging
  messagingSOHub: `${environment.apiUrl}/serviceOrderHub/`,
  soChatAdd: `${environment.apiUrl}/api/chat/SoChatAdd/`,
  soChatGetList: `${environment.apiUrl}/api/chat/GetAllChatsForSO/`,
  //End Messaging

  //Start - Job Labor Planning
  jobLaborPlanningGetCalendarData: `${environment.apiUrl}/api/JobLaborPlanning/GetCalendarData`,
  jobLaborPlanningGetCityList: `${environment.apiUrl}/api/JobLaborPlanning/GetCityListForAssignedUser`,
  jobLaborPlanningShowList: `${environment.apiUrl}/api/JobLaborPlanning/GetShowListForJobPlanning`,
  jobLaborPlanningGetJobTileList: `${environment.apiUrl}/api/JobLaborPlanning/GetJobTilesByShowIdAndDate`,
  jobLaborAllocationAddUpdate: `${environment.apiUrl}/api/JobLaborPlanning/JobLaborAllocationAddUpdate`,
  jobLaborAllocationDelete: `${environment.apiUrl}/api/JobLaborPlanning/JobLaborAllocationDelete/`,
  jobLaborPlanLeadManUpdate: `${environment.apiUrl}/api/JobLaborPlanning/JobLaborPlanLeadManUpdate/`,
  jobLaborPlanUpdateTimeAndMoveDate: `${environment.apiUrl}/api/JobLaborPlanning/JobLaborPlanUpdateTimeAndMoveDate`,
  jobLaborPlanNotRequiredSlotUpdate: `${environment.apiUrl}/api/JobLaborPlanning/JobLaborPlanNotRequiredSlotUpdate`,
  jobLaborPlanGetAllUnbillHrsByShowId: `${environment.apiUrl}/api/JobLaborPlanning/GetAllUnbillHrsByShowId/`,
  jobLaborPlanShowUnbillUpdate: `${environment.apiUrl}/api/JobLaborPlanning/ShowUnbillHrsUpdate`,
  jobLaborPlanUnbillHrsDelete: `${environment.apiUrl}/api/JobLaborPlanning/ShowUnbillHrsDelete/`,
  jobLaborPlanShowUnbillAdd: `${environment.apiUrl}/api/JobLaborPlanning/ShowUnbillHrsAdd`,
  jobLaborPlanAllocExcelDataByShowId: `${environment.apiUrl}/api/JobLaborPlanning/GetLaborAllocationExcelDataByShowId`,

  jobLaborGetOnUnderOverBudgetJobs: `${environment.apiUrl}/api/OverRunJob/GetAllOnUnderOverActiveJobsForCM/`,
  jobLaborOverRunJobResolved: `${environment.apiUrl}/api/OverRunJob/ResolvedOverRunJob`,
  jobLaborCheckInGetData: `${environment.apiUrl}/api/JobLaborCheckIn/GetCheckInDataByShowAndDate`,
  jobLaborCheckInUpdate: `${environment.apiUrl}/api/JobLaborCheckIn/LaborCheckInUpdate`,
  jobLaborPlanAssignedShowListForCityManager: `${environment.apiUrl}/api/JobLaborPlanning/GetAssignedShowListForCityManager`,
  jobLaborPlanningGetAllAssinedCityList: `${environment.apiUrl}/api/JobLaborPlanning/GetAllCityListForAssignedUser`,
  jobLaborPlanningGetAllAssignedCityForCheckIn: `${environment.apiUrl}/api/JobLaborPlanning/GetAllCityListForCheckIn`,
  jobLaborDailyActivitiesGetAll: `${environment.apiUrl}/api/JobLaborDailyActivity/GetJobLaborDailyActivities`,
  jobLaborGetTimesheetBySOAndDate: `${environment.apiUrl}/api/JobLaborDailyActivity/GetJobLaborTimeSheetBySOAndDate`,
  jobLaborUpdateTimesheet: `${environment.apiUrl}/api/JobLaborDailyActivity/JobLaborTimeSheetUpdate`,
  jobLaborCMOnBudgetMarkReviewedStatusUpdate: `${environment.apiUrl}/api/JobLaborDailyActivity/CMOnBudgetMarkReviewedStatusUpdate`,
  jobLaborGetAllSoScopeMaterialsForCMLM: `${environment.apiUrl}/api/JobLaborDailyActivity/GetAllJobLaborSoScopeMaterialsCMLM/`,
  jobLaborGetAllSoScopeEquipmentForCMLM: `${environment.apiUrl}/api/JobLaborDailyActivity/GetAllJobLaborSoScopeEquipmentCMLM/`,

  jobLaborSoScopeEquipmentDeleteForCMLM: `${environment.apiUrl}/api/JobLaborDailyActivity/JobLaborEquipmentCustomDeleteForCMLM/`,
  jobLaborSoScopeEquipmentAddUpdateForCMLM: `${environment.apiUrl}/api/JobLaborDailyActivity/JobLaborScopeEquipmentAddUpdateForCMLM`,

  jobLaborSoScopeMaterialDeleteForCMLM: `${environment.apiUrl}/api/JobLaborDailyActivity/JobLaborMaterialCustomDeleteForCMLM/`,
  jobLaborSoScopeMaterialUpdateForCMLM: `${environment.apiUrl}/api/JobLaborDailyActivity/JobLaborMaterialAddUpdateForCMLM`,
  jobDailyActivityInboundInvAddUpdate: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityInboundInvAddUpdate`,
  jobDailyActivityGetInboundInvDetails: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityGetInboundInvDetails`,
  jobDailyActivitySODetails: `${environment.apiUrl}/api/JobLaborDailyActivity/GetJobDailyActivitySODetails`,
  jobDailyActivityGetInboundInvFileUpload: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityGetInboundInvFileUpload`,
  jobDailyActivityInboundInvFileDelete: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityInboundInvFileDelete/`,
  jobDailyActivityInboundInvFileDownload: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityInboundInvFileDownload/`,
  jobDailyActivityInstDismJwCategoryAddUpdate: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityInstDismJwCategoryAddUpdate`,
  jobDailyActivityInstDismOnBudgetCategoryAddUpdate: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityInstDismOnBudgetCategoryAddUpdate`,
  jobDailyActivityInstDismJwDetails: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityInstDismJwDetails`,
  jobDailyActivityInstDismJwFileUpload: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityInstDismJwFileUpload`,
  jobDailyActivityInstDismJwForOnBudgetSubContractor: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityInstDismJwForOnBudgetSubContractor`,
  jobDailyActivityInstDismJwFileDelete: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityInstDismJwFileDelete/`,
  jobDailyActivityInstDismDeleteOnBudgetSubContractor: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityInstDismDeleteOnBudgetSubContractor`,
  jobDailyActivityInstDismJWFileDownload: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityInstDismJWFileDownload/`,
  jobLaborPlanGetLaborAllocatedDetailsByIdAndDate: `${environment.apiUrl}/api/JobLaborPlanning/GetLaborAllocatedDetailsByIdAndDate`,
  jobLaborPlanGetLaborAllocatedDetailsByIdAndDateList: `${environment.apiUrl}/api/JobLaborPlanning/GetLaborAllocatedDetailsByIdAndDateList`,
  jobDailyActivityInboundInvInstDismJwDetails: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityInboundInvInstDismJwDetails/`,
  jobDailyActivityReportDownload: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityReportDownload/`,
  jobDailyActivityGetClientContacts: `${environment.apiUrl}/api/JobLaborDailyActivity/GetJobDailyActivityReportContacts`,
  jobDailyActivityCompleteAndSend: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityReportSend`,
  jobDailyActivityReportMarkAsComplete: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityReportMarkComplete`,
  jobDailyActivityGetCMLeadManDailyCheckListUpdate: `${environment.apiUrl}/api/JobLaborDailyActivity/GetCMLeadManDailyCheckListUpdate`,
  jobDailyActivityLMSendReportToCMReviewedByCM: `${environment.apiUrl}/api/JobLaborDailyActivity/LMSendDailyReportToCMReviewedByCM`,
  jobDailyActivityGetOnBudgetComparison: `${environment.apiUrl}/api/JobLaborDailyActivity/GetOnBudgetComparison`,

  jobPayrollEntryGetByWeek: `${environment.apiUrl}/api/PayrollEntry/GetPayrollEntryByWeek`,
  jobPayrollEntryInititalShowListGetByWeek: `${environment.apiUrl}/api/PayrollEntry/GetPayrollEntryShowInitialData`,
  jobPayrollEntryAddUpdate: `${environment.apiUrl}/api/PayrollEntry/PayrollEntryAddUpdate`,
  jobPayrollEntrySubmit: `${environment.apiUrl}/api/PayrollEntry/PayrollEntrySubmit`,
  jobPayrollEntryRequestForCorrection: `${environment.apiUrl}/api/PayrollEntry/PayrollEntryRequestCorrection/`,
  jobBillingEntryGetList: `${environment.apiUrl}/api/BillingEntry/GetBillingEntryList`,
  jobBillingEntryGetDetailsByShowId: `${environment.apiUrl}/api/BillingEntry/GetBillingEntryDetailsByShowId`,
  jobShowListforBillingEntryByCityId: `${environment.apiUrl}/api/BillingEntry/GetShowListForBillingEntryByCityId/`,
  jobPayrollEntryCMLayoutChangeRequest: `${environment.apiUrl}/api/PayrollEntry/CMLayoutSlotChangeRequestUpdate`,
  jobManualPayrollEntryGetByWeek: `${environment.apiUrl}/api/PayrollEntry/GetManualPayrollEntry`,
  jobManualPayrollEntryAdd: `${environment.apiUrl}/api/PayrollEntry/ManualPayrollEntryAdd`,
  jobManualPayrollEntryUpdate: `${environment.apiUrl}/api/PayrollEntry/ManualPayrollEntryUpdate`,
  jobManualPayrollEntryDelete: `${environment.apiUrl}/api/PayrollEntry/ManualPayrollEntryDelete`,
  jobManualPayrollEntryGetById: `${environment.apiUrl}/api/PayrollEntry/GetManualPayrollEntryById`,
  jobBillingEntryMasterAddUpdate: `${environment.apiUrl}/api/BillingEntry/BillingEntryMasterAddUpdate`,
  jobBillingEntryAddUpdate: `${environment.apiUrl}/api/BillingEntry/BillingEntryAddUpdate`,
  jobBillingEntryBlindCallDelete: `${environment.apiUrl}/api/BillingEntry/BillingEntryBlindCallDelete/`,
  jobBillingEntrySubmitSO: `${environment.apiUrl}/api/BillingEntry/BillingEntrySubmitSO/`,
  jobBillingEntrySubmitShow: `${environment.apiUrl}/api/BillingEntry/BillingEntrySubmitShow/`,
  jobPayrollEntryReportGet: `${environment.apiUrl}/api/PayrollEntry/GetPayrollEntryReport`,
  jobPayrollEntryCorrectionReportGet: `${environment.apiUrl}/api/PayrollEntry/GetPayrollEntryCorrectionReport`,
  jobPayrollEntrySnapshotGet: `${environment.apiUrl}/api/PayrollEntry/GetPayrollEntrySnapshot`,
  jobBillingEntryReportGet: `${environment.apiUrl}/api/BillingEntry/GetBillingEntryReportList`,
  jobBillingEntryReportViewGet: `${environment.apiUrl}/api/BillingEntry/GetBillingEntryReportView/`,
  jobBillingEntryReportDetailsGet: `${environment.apiUrl}/api/BillingEntry/GetBillingEntryReportDetails/`,
  jobPayrollEntryCorrectionEyeballReportGet: `${environment.apiUrl}/api/PayrollEntry/GetPayrollEntryCorrectionEyeballReport`,
  jobDailyActivityPlatinumInstructionAnsByCMLM: `${environment.apiUrl}/api/JobLaborDailyActivity/PlatinumInstructionAnsByCMLM`,
  jobBillingEntryUpdateAdjustmentAmount: `${environment.apiUrl}/api/BillingEntry/UpdateAdjustmentAmount`,
  jobLaborPlanningSendSMSToLaborForAvailability: `${environment.apiUrl}/api/JobLaborPlanning/SendSMSToLaborForAvailability/`,
  jobLaborPlanningSendVerbalConfirmationToLaborForAvailability: `${environment.apiUrl}/api/JobLaborPlanning/SendVerbalConfirmationToLaborForAvailability/`,

  jobBillingEntryAcctgAdjustSTOTDTHrs: `${environment.apiUrl}/api/BillingEntry/AcctgAdjustBillingEntrySTOTDTHrs`,
  jobBillingEntryAcctgAdjustSTOTDTComment: `${environment.apiUrl}/api/BillingEntry/AcctgAdjustBillingEntrySTOTDTComment`,
  jobBillingEntryAcctgAdjustMaterial: `${environment.apiUrl}/api/BillingEntry/AcctgAdjustBillingEntryMaterial`,
  jobBillingEntryAcctgAdjustAdditionalItem: `${environment.apiUrl}/api/BillingEntry/AcctgAdjustBillingEntryAdditionalItems`,
  jobBillingEntryAcctgAdjustEquipment: `${environment.apiUrl}/api/BillingEntry/AcctgAdjustBillingEntryEquipment`,
  jobBillingEntryAcctgAdjustSTOTDTRate: `${environment.apiUrl}/api/BillingEntry/AcctgAdjustBillingEntrySTOTDTRate`,
  jobBillingEntryAcctgAdjustSupervPercUpdate: `${environment.apiUrl}/api/BillingEntry/AcctgAdjustBillingEntrySupvPerc`,
  jobBillingEntryAcctgAdjustMaterialDelete: `${environment.apiUrl}/api/BillingEntry/AcctgAdjustBillingEntryMaterialDelete/`,
  jobBillingEntryAcctgAdjustEquipmentDelete: `${environment.apiUrl}/api/BillingEntry/AcctgAdjustBillingEntryEquipmentDelete/`,
  jobBillingEntryAcctgAdjustAdditionalItemDelete: `${environment.apiUrl}/api/BillingEntry/AcctgAdjustBillingEntryAdditionalItemDelete/`,
  jobLaborPlanningReportingLeadmanAddUpdate: `${environment.apiUrl}/api/JobLaborPlanning/ReportingLeadmanAddUpdate`,
  jobLaborPlanningNotifyToAllLabor: `${environment.apiUrl}/api/JobLaborPlanning/NotifySendSMSToLaborForAvailability`,

  //End - Job Labor Planning

  //CM Dashboard START
  jobLaborOverRunJobDashboardData: `${environment.apiUrl}/api/CmDashboard/GetJobRunningOverDashboardInfo/`,
  jobLaborTodaysCardData: `${environment.apiUrl}/api/CmDashboard/GetTodaysCMDashboardInfo/`,
  jobLaborPayrollEntryCurrentData: `${environment.apiUrl}/api/CmDashboard/GetPayrollEntryCurrentWeekData/`,
  jobLaborBillingEntryCurrentData: `${environment.apiUrl}/api/CmDashboard/GetBillingEntryDataForDashboard/`,
  jobLaborDailyReportData: `${environment.apiUrl}/api/CmDashboard/GetDailyReportDataForDashboard/`,
  jobLaborGetImportantJobUpdates: `${environment.apiUrl}/api/CmDashboard/GetImportantJobUpdates/`,
  jobLaborImportantJobUpdateClear: `${environment.apiUrl}/api/CmDashboard/ImportantJobUpdateWidgetClear`,
  jobLaborGetPayrollCorrectionLastWeek: `${environment.apiUrl}/api/CmDashboard/GetPayrollCorrectionLastWeek/`,
  //CM Dashboard END

  //Application Update Start
  applicationUpdateGetAll: `${environment.apiUrl}/api/ApplicationUpdate/GetAllApplicationUpdates`,
  applicationUpdateGetAllByDate: `${environment.apiUrl}/api/ApplicationUpdate/GetAllApplicationUpdatesByDate`,

  //Application Update End

  //Accounting Start
  accountingDashboardGetInfo: `${environment.apiUrl}/api/Accounting/GetDashboardInfo`,
  accountingDashboardSoListGetInfo: `${environment.apiUrl}/api/Accounting/GetAccountingDashboardSOList`,
  accountingDepositInvoiceReportGet: `${environment.apiUrl}/api/Accounting/GetAccountingDepositInvoiceReport/`,
  accountingDepositReceived: `${environment.apiUrl}/api/Accounting/DepositReceived`,
  accountingDepositInvoiceSend: `${environment.apiUrl}/api/Accounting/DepositInvoiceSend`,
  accountingFinalInvoiceSend: `${environment.apiUrl}/api/Accounting/FinalInvoiceSend`,
  accountingSoSendToAccounting: `${environment.apiUrl}/api/Accounting/SoSendToAccounting/`,
  accountingPayrollBillingReportGet: `${environment.apiUrl}/api/Accounting/GetAccountingPayrollBillingEntryReport`,
  accountingApprovePayrollEntryCorrection: `${environment.apiUrl}/api/Accounting/PayrollEntryRequestApprove/`,
  accountingAddPayrollEntryCorrectionComment: `${environment.apiUrl}/api/Accounting/PayrollEntryAddCorrectionComment`,
  accountingMarkSOAsReviewed: `${environment.apiUrl}/api/Accounting/MarkAsReviewed/`,
  accountingMarkSOPayrollComplete: `${environment.apiUrl}/api/Accounting/MarkAsSOPayrollComplete/`,
  accountingMarkShowPayrollComplete: `${environment.apiUrl}/api/Accounting/MarkAsShowPayrollComplete/`,
  accountingSoMarkAsAccountingReady: `${environment.apiUrl}/api/Accounting/SoMarkAsAccountingReady/`,
  accountingClearSubcontractorJobCount: `${environment.apiUrl}/api/Accounting/ClearSubcontractorJobCount/`,

  //Accounting End

  //Account Manager Start
  amGetPlatinumReport: `${environment.apiUrl}/api/AccountManager/GetPlatinumReport`,
  amDailyActivityReportSend: `${environment.apiUrl}/api/AccountManager/AMDailyActivityReportSend`,
  amGetEstimateFollowUpReport: `${environment.apiUrl}/api/AccountManager/GetEstimateFollowUpReport`,
  amEstimateFollowUpSend: `${environment.apiUrl}/api/AccountManager/AMEstimateFollowUpSend`,
  amEstimateFollowUpUpdateStatusNotes: `${environment.apiUrl}/api/AccountManager/AMEstimateFollowUpUpdateStatusNotes`,
  amGetFollowUp906030Report: `${environment.apiUrl}/api/AccountManager/GetFollowUp906030Report`,
  amFollowUp906030DateUpdate: `${environment.apiUrl}/api/AccountManager/AMFollowUp906030DateUpdate`,

  //90-60-30-Followup-v2 - start
  amGetFollowUp906030ReportV2: `${environment.apiUrl}/api/AccountManager/GetFollowUp906030ReportV2`,
  amFollowUp906030UpdateStatusNotesV2: `${environment.apiUrl}/api/AccountManager/AMFollowUp906030UpdateStatusNotesV2`,
  amFollowUp906030SendV2: `${environment.apiUrl}/api/AccountManager/AMFollowUp906030SendV2`,
  //90-60-30-Followup-v2 - end

  amFollowUp906030Send: `${environment.apiUrl}/api/AccountManager/AMFollowUp906030Send`,
  amFollowUp906030UpdateStatusNotes: `${environment.apiUrl}/api/AccountManager/AMFollowUp906030UpdateStatusNotes`,
  amPlatinumInstructionDueReportGet: `${environment.apiUrl}/api/AccountManager/GetPlatinumInstructionDueReport`,
  amPlatinumInstructionDueReportGetBySOId: `${environment.apiUrl}/api/AccountManager/GetPlatinumInstDueReportBySOId/`,
  amPlatinumInstructionJobDateWiseReportGet: `${environment.apiUrl}/api/AccountManager/GetPlatinumInstJobDateWiseReport`,
  amPlatinumInstructionGetAllReport: `${environment.apiUrl}/api/AccountManager/GetPlatinumInstructionAllReport/`,
  amPlatinumInstructionAddUpdate: `${environment.apiUrl}/api/AccountManager/PlatinumInstructionAddUpdate`,
  amPlatinumInstructionFileDownload: `${environment.apiUrl}/api/AccountManager/PlatinumInstructionFileDownload/`,
  amPlatinumInstructionFileDelete: `${environment.apiUrl}/api/AccountManager/PlatinumInstructionFileDelete/`,
  amPlatinumInstructionDelete: `${environment.apiUrl}/api/AccountManager/PlatinumInstructionDelete/`,
  amAeDailyActivityAddUpdateComment: `${environment.apiUrl}/api/AccountManager/AMAEDailyActivityAddUpdateComment`,
  amPlatinumInstructionUpdate: `${environment.apiUrl}/api/AccountManager/PlatinumInstructionUpdate`,
  amPlatinumInstDueReqNotReqForDay: `${environment.apiUrl}/api/AccountManager/AMPlatinumInstDueReqNotReqForDay`,
  amPlatinumInstructionFileUpload: `${environment.apiUrl}/api/AccountManager/PlatinumInstructionFileUpload`,
  amPlatinumInstructionUpdateSeq: `${environment.apiUrl}/api/AccountManager/PlatinumInstructionUpdateSeq`,
  //Account Manager End

  //Platinum Instruction Start
  platinumInstTemplateGetList: `${environment.apiUrl}/api/PlatinumInstructionTemplate/GetPlatinumInstructionTemplateList`,
  platinumInstTemplateGetById: `${environment.apiUrl}/api/PlatinumInstructionTemplate/GetPlatinumInstructionTemplateById/`,
  platinumInstTemplateAddUpdate: `${environment.apiUrl}/api/PlatinumInstructionTemplate/PlatinumInstructionTemplateAddUpdate`,
  platinumInstTemplateFileDownload: `${environment.apiUrl}/api/PlatinumInstructionTemplate/PlatinumInstructionTemplateFileDownload/`,
  platinumInstTemplateGetListWithFile: `${environment.apiUrl}/api/PlatinumInstructionTemplate/GetPlatinumInstructionTemplateWithFileList`,
  platinumInstTemplateGetListWithFileBySO: `${environment.apiUrl}/api/PlatinumInstructionTemplate/GetPlatinumInstTemplateWithFileListBySO/`,

  //Platinum Instruction End

  //Account Supervisor Start
  asOrderCountAndOutstandingEstimatesGet: `${environment.apiUrl}/api/AccountSupervisor/GetOrderCountAndOutstandingEstimates`,
  asPlatinumReportCountGet: `${environment.apiUrl}/api/AccountSupervisor/GetASPlatinumReportCount`,
  asAMCalendarData: `${environment.apiUrl}/api/AccountSupervisor/GetCalendarDataForASAM`,
  //Account Supervisor End


  //Common Dashboard Start
  commonDashboardOrderEstDashboardData: `${environment.apiUrl}/api/CommonDashboard/GetCurrentOrderEstDashboardData`,
  //Common Dashboard End

  //Report Start
  reportAuditGet: `${environment.apiUrl}/api/Report/GetAuditReport`,
  reportAuditCityShowListGet: `${environment.apiUrl}/api/Report/GetAuditReportCityShowList`,

  reportGetJobUpdateReportCityList: `${environment.apiUrl}/api/Report/GetJobUpdateReportCityList`,
  reportGetJobUpdateReportShowList: `${environment.apiUrl}/api/Report/GetJobUpdateReportShowList`,
  reportGetJobUpdateReportBySOId: `${environment.apiUrl}/api/Report/GetJobUpdateReportBySOId/`,
  reportJobUpdateViewedUpdateByUser: `${environment.apiUrl}/api/Report/JobUpdateViewedUpdateByUser/`,
  reportJobUpdateViewedBoothFilesUpdateByUser: `${environment.apiUrl}/api/Report/JobUpdateViewedBoothFilesUpdateByUser/`,
  reportGetCityHoursReportList: `${environment.apiUrl}/api/Report/GetCityHoursReportList`,
  reportGetCityHoursInitialDataList: `${environment.apiUrl}/api/Report/GetCityHoursInitialDataList`,
  reportGetRankingInitialDataList: `${environment.apiUrl}/api/Report/GetRankingReportInitialDataList`,
  reportGetRankingReport: `${environment.apiUrl}/api/Report/GetRankingReport`,
  reportGetShowSpecificReport: `${environment.apiUrl}/api/Report/GetShowSpecificReport`,
  reportGetShowSpecificInitialDataList: `${environment.apiUrl}/api/Report/GetShowSpecificReportInitialDataList`,
  reportGetJobPerformanceReport: `${environment.apiUrl}/api/Report/GetJobPerformanceReport`,
  reportGetJobPerformanceReportInitialDataList: `${environment.apiUrl}/api/Report/GetJobPerformanceReportInitialDataList`,

  reportGetShowComparisonReport: `${environment.apiUrl}/api/Report/GetShowComparisonReport`,
  reportGetShowComparisonReportInitialDataList: `${environment.apiUrl}/api/Report/GetShowComparisonReportInitialDataList`,
  reportGetPayrollLaborHoursReport: `${environment.apiUrl}/api/Report/GetPayrollLaborHoursReport`,
  reportGetTravelLeadReport: `${environment.apiUrl}/api/Report/GetTravelLeadReport`,
  reportGetEstimatorSoSearchReport: `${environment.apiUrl}/api/Report/GetEstimatorSoSearchReport`,

  //Report End

  //Show Job Central Start
  showCentralListGet: `${environment.apiUrl}/api/ShowJobCentral/GetShowCentralList`,
  showCentralGetByShowId: `${environment.apiUrl}/api/ShowJobCentral/GetShowCentralDetailsByShowId/`,
  jobCentralGetBySOId: `${environment.apiUrl}/api/ShowJobCentral/GetJobCentralBySOId/`,
  // DPP-143: reports emailed for the SO — every version, no expiry for staff, and a new link to share
  jobCentralGetSentReports: `${environment.apiUrl}/api/SentReport/GetSentReports/`,
  jobCentralDownloadSentReport: `${environment.apiUrl}/api/SentReport/DownloadSentReport`,
  jobCentralCreateReportShareLink: `${environment.apiUrl}/api/SentReport/CreateShareLink`,
  jobCentralGetJobCentralForReportLink: `${environment.apiUrl}/api/SentReport/GetJobCentralForLink/`,
  //Show Job Central End

  //Expose URL Start
  exposeVerifyLaborAvailability: `${environment.apiUrl}/api/Expose/VerifyLaborAvailabilityLink/`,
  exposeConfirmLaborAvailability: `${environment.apiUrl}/api/Expose/ConfirmLaborAvailability`,
  exposeResolveShortLink: `${environment.apiUrl}/api/ShortLink/ResolveShortLink/`,
  // DPP-143 public report link page (anonymous)
  exposeGetReportLink: `${environment.apiUrl}/api/ReportLink/GetReportLink/`,
  exposeReportLinkDownload: `${environment.apiUrl}/api/ReportLink/Download/`,
  //Expose URL End

  //Leadership Operation Start
  leadershipOperationGetDashboardDetails: `${environment.apiUrl}/api/LeadershipOperation/GetLeadershipOpDashboardDetails`,
  leadershipOperationGetEstimatedRevenueMonthlyWithoutJobType: `${environment.apiUrl}/api/LeadershipOperation/GetLeadershipOpEstimatedRevenueMonthlyWithoutJobType`,
  leadershipOperationGetEstimatedRevenueMonthlyWithJobType: `${environment.apiUrl}/api/LeadershipOperation/GetLeadershipOpEstimatedRevenueMonthlyWithJobType`,

  leadershipOperationGetAnticipatedActualRevenueMonthly: `${environment.apiUrl}/api/LeadershipOperation/GetLeadershipOpAnticipatedActualRevenueMonthly`,
  leadershipOperationGetEstimatedRevenueInfo: `${environment.apiUrl}/api/LeadershipOperation/GetLeadershipOpEstimatedRevenueInfo`,
  leadershipOperationGetOverrun: `${environment.apiUrl}/api/LeadershipOperation/GetLeadershipOpOverrun`,
  leadershipOperationGetDashboardTile: `${environment.apiUrl}/api/LeadershipOperation/GetLeadershipDashboardTileDetails`,

  //Leadership Operation End

  //Email Viewer Start
  emailViewerGetList: `${environment.apiUrl}/api/EmailViewer/GetEmails`,
  emailViewerGetListWithoutAttachment: `${environment.apiUrl}/api/EmailViewer/GetEmailsWithoutAttachmentAsync`,
  emailViewerQBGetListWithoutAttachment: `${environment.apiUrl}/api/EmailViewer/GetQBEmailsWithoutAttachmentAsync`,

  emailViewerGetById: `${environment.apiUrl}/api/EmailViewer/GetEmailById/`,
  emailViewerDownloadAttachment: `${environment.apiUrl}/api/EmailViewer/DownloadAttachment`,
  // DPP-143: the stored report of an Inbox copy of a queued report email
  emailViewerDownloadStoredDocument: `${environment.apiUrl}/api/EmailViewer/DownloadStoredDocument`,

  //Email Viewer End
  //Photo gallery - start
  publicGetPhotoGallery: `${environment.apiUrl}/api/PublicGallery/GetPhotoGallery/`,
  publicGetGalleryPhotoComments: `${environment.apiUrl}/api/PublicGallery/GetGalleryPhotoComments/`,
  publicAddGalleryComment: `${environment.apiUrl}/api/PublicGallery/AddGalleryComment/`,

  galleryGetGallery: `${environment.apiUrl}/api/PhotoGallery/GetGallery`,
  galleryGetPhotoComments: `${environment.apiUrl}/api/PhotoGallery/GetPhotoComments`,
  galleryAddInternalComment: `${environment.apiUrl}/api/PhotoGallery/AddInternalComment`,
  galleryGetSentHistory: `${environment.apiUrl}/api/PhotoGallery/GetSentHistory`,
  galleryGetAllowDirectPhotos: `${environment.apiUrl}/api/PhotoGallery/GetAllowDirectPhotos`,
  gallerySetAllowDirectPhotos: `${environment.apiUrl}/api/PhotoGallery/SetAllowDirectPhotos`,
  galleryPdfDownload: `${environment.apiUrl}/api/PhotoGallery/GalleryPdfDownload`,
  galleryEmailToSafety: `${environment.apiUrl}/api/PhotoGallery/EmailGalleryToSafety`,
  dailyActivityFileDownload: `${environment.apiUrl}/api/JobLaborDailyActivity/JobDailyActivityInstDismJWFileDownload/`,
  //Photo gallery - end
};
